export default "__VITE_ASSET__CKSiLVIc__"